import { render, staticRenderFns } from "./biu-select-table.vue?vue&type=template&id=40c35e16&"
import script from "./biu-select-table.vue?vue&type=script&lang=ts&"
export * from "./biu-select-table.vue?vue&type=script&lang=ts&"
import style0 from "./biu-select-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports